import React from 'react';
import DebugClickWrapper from './DebugClickWrapper';
import { MyInfoStyles, StyledMyInfoContainerSkeleton } from './MyInfoStyles.styled';
import { Avatar } from '@mindly/ui-components';
import { IonSkeletonText } from '@ionic/react';
import { useSelector } from 'react-redux';
import { userSelector } from '../../../redux/user/selector';

type MyInfoComponentPropsType = {
  showSkeleton: boolean;
  myPhotoSrc?: string;
  buttonText?: string;
  buttonHandler?: () => void;
};

const MyInfoComponent: React.FC<MyInfoComponentPropsType> = ({
  showSkeleton,
  myPhotoSrc,
  buttonText,
  buttonHandler,
}) => {
  const currentUser = useSelector(userSelector);

  return showSkeleton ? (
    <StyledMyInfoContainerSkeleton style={{ padding: '0px 16px 0px 16px' }}>
      <IonSkeletonText
        animated
        style={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          padding: '12px',
        }}
      />

      <IonSkeletonText
        animated
        style={{
          justifyContent: 'center',
          width: '70%',
          height: '29px',
          borderRadius: '4px',
          margin: 0,
        }}
      />
    </StyledMyInfoContainerSkeleton>
  ) : (
    <MyInfoStyles className="my-info">
      <div className="avatar-container">
        <Avatar firstName={currentUser?.display_name} src={myPhotoSrc} dimensions={72} withBorder={false} />
      </div>
      <div className="info-container">
        <div className="pro-badge-container"></div>
        <div className="name-container">
          <DebugClickWrapper>
            <span className="name inter-semi-bold">{currentUser?.display_name ?? 'Невідомий'}</span>
          </DebugClickWrapper>
        </div>
        {buttonText?.length && (
          <button className={'action-button'} onClick={buttonHandler}>
            {buttonText}
          </button>
        )}
      </div>
    </MyInfoStyles>
  );
};

export default MyInfoComponent;
